import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroViajeList;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
    /**Errores de validacion */
    errors?: validation.Result<Entity>;
}


export class FiltroEditor extends React.PureComponent<Props> {
    getField = formfields(() => this.props, () => this.props.errors || {});

    render() {
        const { getField, props } = this;

        const Camion = getField(selectores.Camion);
        const Sucursal = getField(selectores.Sucursal);
        const Chofer = getField(selectores.ChoferRuta);
        const DateTime = getField(kea.DateTime);
        const Status = getField(selectores.StatusViajeRuta);
        const Number = getField(kea.Number);

        return (
            <div>
                {kea.autogrid(3, [
                    <DateTime field="FechaCreacionInicio" label="Fecha de creación (inicio)" />,
                    <DateTime field="FechaCreacionFinal" label="Fecha de creación (final)" />,
                    <Status field="Status" />,
                    <Sucursal field="IdSucursalOrigen" label="Origen" />,
                    <Sucursal field="IdSucursalDestino" label="Destino" />,
                    <Camion field="IdCamion" label="Camión" />,
                    <Chofer field="IdChoferRuta" label="Chofer" />,
                    <Number field="Folio" />
                ])}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/list/filtro.tsx